import { Outlet } from "react-router-dom"
import PageContent from "~/ui/PageContent"

const AdminScreen = () => {
  return (
    <PageContent>
      <Outlet />
    </PageContent>
  )
}

export default AdminScreen
